import generateCellNumber from './generateCellNumber.js';
export default function generateViews(_ref) {
  var stickyRowsCount = _ref.stickyRowsCount,
      stickyColumnsCount = _ref.stickyColumnsCount;

  if (!stickyRowsCount && !stickyColumnsCount) {
    return '';
  }

  var views = '';
  views += '<sheetViews>';
  views += '<sheetView tabSelected="1" workbookViewId="0">';
  views += "<pane ySplit=\"".concat(stickyRowsCount || 0, "\" xSplit=\"").concat(stickyColumnsCount || 0, "\" topLeftCell=\"").concat(generateCellNumber(stickyColumnsCount || 0, (stickyRowsCount || 0) + 1), "\" activePane=\"bottomRight\" state=\"frozen\"/>");
  views += '</sheetView>';
  views += '</sheetViews>';
  return views;
}
//# sourceMappingURL=views.js.map